export * from './ProtectedRoute.js';
export * from './useAuth.js';

// @ts-expect-error: esbuild injection
// eslint-disable-next-line @typescript-eslint/no-unsafe-call
((feature, vaadinObj = (globalThis.Vaadin ??= {})) => {
  vaadinObj.registrations ??= [];
  vaadinObj.registrations.push({
    is: feature ? `@vaadin/hilla-react-auth/${feature}` : '@vaadin/hilla-react-auth',
    version: '24.8.6',
  });
})();
